import { Controller } from "@hotwired/stimulus";

function buildMarkerSvg(marker) {
  return `
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37"  viewBox="0 0 26 37">
      <g fill="none">
        <path d="M13 0C5.817 0 0 5.773 0 12.918c0 7.655 5.59 10.526 9.555 17.16C12.09 34.321
          11.342 37 13 37c1.723 0 .975-2.743 3.445-6.858C20.085 23.86 26 20.605 26 12.918 26
          5.773 20.183 0 13 0z" class="${marker.border_class}"/>
        <path
          d="M13.017 35c-.233 0-.3-.065-.7-1.275-.332-1.046-.832-2.648-2.13-4.61-1.265-1.928-2.596-3.498-3.861-5.002C3.363
          20.517 1 17.706 1 12.64 1.033 6.199 6.393 1 13.017 1S25 6.23 25 12.639c0 5.067-2.33 7.911-5.326
          11.507-1.232 1.504-2.53 3.073-3.795 4.97-1.265 1.928-1.797 3.498-2.13 4.544-.4 1.275-.5 1.34-.732 1.34z"
          class="${marker.background_class}"/>
        <text text-anchor="middle" dy=".3em" x="13" y="14" font-family="Roboto, Arial, sans-serif"
          font-size="16px" class="fill-white">${marker.label}</text>
      </g>
    </svg>
  `;
}

export default class extends Controller {
  async connect() {
    this.connected = true;

    const { default: Leaflet } = await import("leaflet");

    if (!this.connected || this.map) return;

    this.mapPadding = parseInt(this.element.dataset.padding || 20);

    const markerValues = JSON.parse(this.element.dataset.markers || "[]");

    const layer = new Leaflet.TileLayer(
      "https://api.mapbox.com/styles/v1/mapbox/light-v11/tiles/512/{z}/{x}/{y}?access_token=pk.eyJ1IjoibG9hZGFyIiwiYSI6ImNsZzI0ajNmcjAxemYzY28xNmdlOXJ5cHQifQ.jSeWdEb4i_x74KDCJVjUGQ",
      {
        attribution:
          '<span style="font-size: 10px">© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a></span>',
      },
    );

    this.map = Leaflet.map(this.element, {
      layers: [layer],
      zoomControl: false,
      zoomSnap: 0.7,
      zoomDelta: 1,
    });
    this.map.attributionControl.setPrefix(false);

    if (markerValues.length > 1) {
      this.map.fitBounds(
        new Leaflet.LatLngBounds(markerValues.map((marker) => marker.position)),
        { padding: [10, this.mapPadding, 10, 0] },
      );
    } else if (markerValues.length === 1) {
      this.map.setView(markerValues[0].position, 7);
    } else {
      this.map.setView([54, -4], 4);
    }

    this.addMarkers(markerValues, Leaflet);
  }

  disconnect() {
    this.connected = false;
    this.map?.off();
    this.map?.remove();
    this.map = null;
  }

  addMarkers(markerValues, Leaflet) {
    markerValues.forEach((data) => {
      const icon = Leaflet.divIcon({
        html: buildMarkerSvg(data),
        className: "",
        iconSize: [24, 40],
        iconAnchor: [18, 36],
      });

      const marker = Leaflet.marker(Object.values(data.position), { icon });

      const popupContent = document.createElement("div");
      popupContent.textContent = data.title;

      marker.bindPopup(popupContent);
      marker.addTo(this.map);
    });
  }
}
